const THEME_STORAGE_KEY = 'aff-office-ui-theme';

export const LIGHT_THEME = 1;
export const DARK_THEME = 2;

export const getStoredTheme = () => {
  try {
    const value = Number(window.localStorage.getItem(THEME_STORAGE_KEY));
    if (value === LIGHT_THEME || value === DARK_THEME) {
      return value;
    }
  } catch (e) {
    // ignore storage access errors
  }
  return null;
};

export const setStoredTheme = (themeId) => {
  try {
    window.localStorage.setItem(THEME_STORAGE_KEY, String(themeId));
  } catch (e) {
    // ignore storage access errors
  }
};

export const getEffectiveTheme = (profileTheme) => {
  const stored = getStoredTheme();
  if (stored) {
    return stored;
  }
  return Number(profileTheme) === DARK_THEME ? DARK_THEME : LIGHT_THEME;
};

export const applyThemeClass = (themeId) => {
  const html = document.documentElement;
  const nextClass = (html.className || '')
    .split(/\s+/)
    .filter((cls) => cls && !/^theme-\d+$/.test(cls))
    .concat(`theme-${themeId}`)
    .join(' ')
    .trim();
  html.className = nextClass;

  // Clears boot-time inline bg from index.tpl.html when switching themes
  if (Number(themeId) === DARK_THEME) {
    html.style.backgroundColor = '#161616';
    html.style.colorScheme = 'dark';
  } else {
    html.style.backgroundColor = '';
    html.style.colorScheme = '';
  }
};
